import { connect } from 'react-redux';
import UpdateFolderTreeButton from '../../../../components/ParametersPage/ActionButtons/UpdateFolderTreeButton';
import { StoreState } from '../../../../reducers';
import UserAgentUtils from '../../../../utils/userAgent';

const mapStateToProps = (state: StoreState) => {
	const {
		driveList: {
			folderTreeUpdate: {
				isUpdating,
			},
		},
		offlineManager: {
			isPreparingContentStructure,
		},
	} = state;
	const isOffline = !UserAgentUtils.isOnline();
	const isBusy = isUpdating || isPreparingContentStructure;

	return {
		isOffline,
		isBusy,
	};
};

export default connect(mapStateToProps)(UpdateFolderTreeButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ParametersPage/ActionButtons/UpdateFolderTreeButton/index.tsx